var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "highlight-dialog" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            width: "450px",
            center: "",
            "show-close": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            open: _vm.getCatalogContent,
          },
        },
        [
          _c("light-input", {
            staticClass: "cusInput",
            attrs: {
              "max-length": _vm.maxLength,
              "highlight-enabled": true,
              specialCharacterFlag: true,
            },
            model: {
              value: _vm.content,
              callback: function ($$v) {
                _vm.content = $$v
              },
              expression: "content",
            },
          }),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn-plain-primary",
                  attrs: { plain: "", disabled: false },
                  on: { click: _vm.closeDialog },
                },
                [_vm._v(_vm._s(_vm.$t("home.cancelButton")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "btn-primary",
                  attrs: { type: "primary", plain: "" },
                  on: { click: _vm.confirm },
                },
                [_vm._v(_vm._s(_vm.$t("home.sureButton")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }